import { request as umiRequest } from "@umijs/max";

/**
 * 解码 base64 并解析 JSON (支持 UTF-8)
 */
function decodeBase64Data(base64Str: string) {
  try {
    // 使用 TextDecoder 支持 UTF-8 编码
    const binaryString = atob(base64Str);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    const decoder = new TextDecoder("utf-8");
    const decoded = decoder.decode(bytes);
    return JSON.parse(decoded);
  } catch (error) {
    console.error("解码失败:", error);
    throw error;
  }
}

/**
 * 封装的 request，自动处理 base64 编码的 data 字段
 */
async function request<T>(url: string, options?: any): Promise<T> {
  const response = await umiRequest<any>(url, options);

  // 如果响应的 data 字段是 base64 字符串，则解码
  if (response && typeof response === "string") {
    return decodeBase64Data(response) as T;
  }

  return response as T;
}

/**
 * 管理员登录接口
 * POST /api/admin/login
 * admin admin123
 */
export async function login(params: API.LoginParams) {
  return request<API.LoginResult>("/api/admin/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: params,
  });
}

/**
 * 获取当前管理员信息接口
 * GET /api/admin/info
 */
export async function getAdminInfo() {
  return request<API.AdminInfo>("/api/admin/info", {
    method: "GET",
  });
}

/**
 * 获取小记列表接口
 * GET /api/notes
 */
export async function getNoteList(params: {
  remark?: string;
  type?: number;
  content?: string;
  startTime?: string;
  endTime?: string;
  page?: number;
  pageSize?: number;
}) {
  return request<{
    list: API.NoteItem[];
    total: number;
    page: number;
    pageSize: number;
  }>("/api/notes", {
    method: "GET",
    params,
  });
}

/**
 * 创建小记接口
 * POST /api/notes
 */
export async function createNote(data: { remark: string; type: number; content: string }) {
  return request<API.NoteItem>("/api/notes", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data,
  });
}

/**
 * 更新小记接口
 * PUT /api/notes/:id
 */
export async function updateNote(
  id: number,
  data: {
    remark?: string;
    type?: number;
    content?: string;
  },
) {
  return request<API.NoteItem>(`/api/notes/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    data,
  });
}

/**
 * 删除小记接口
 * DELETE /api/notes/:id
 */
export async function deleteNote(id: number) {
  return request<null>(`/api/notes/${id}`, {
    method: "DELETE",
  });
}
